/* Presentation only. v1.2: stable lifecycle plus explicitly curated visual-design dimensions. */
(() => {
  'use strict';
  const manifestNode = document.getElementById('wehuiae-variant-image-options-manifest');
  if (!manifestNode || manifestNode.type !== 'application/json') return;
  let manifest;
  try { manifest = JSON.parse(manifestNode.textContent); } catch { return; }
  if (manifest.version !== '2026-10-19.variant-image-options.candidate.v1' || !Array.isArray(manifest.products)) return;
  const cleanPath = path => {try{return decodeURIComponent(path).replace(/\/$/,'');}catch{return null;}};
  const matches = manifest.products.filter(p => p.enabled === true && /^\d+$/.test(p.product_id) && cleanPath(p.path) === cleanPath(location.pathname));
  if (matches.length !== 1) return;
  const product = matches[0];
  const dimensions = (product.visual_dimensions || []).filter(d => d.enabled === true && typeof d.name === 'string' && (/colou?r/i.test(d.name) || (product.product_id === '15406401290431' && d.name === '4.8m Indoor & Outdoor' && d.curatedVisualColor === true) || /^style:?$/i.test(d.name.trim()) || (d.curatedDesign === true && /^(type|design):?$/i.test(d.name.trim()))) && d.kind === 'VISUAL' && typeof d.visual_confirmation === 'string' && d.visual_confirmation.trim());
  if (!dimensions.length || !Array.isArray(product.option_names) || !Array.isArray(product.variants)) return;
  const pickerSelector = 'variant-picker[data-product-id="'+product.product_id+'"]';
  const ownImage = 'img[data-we-variant-image-decoration="1"]';
  let debounceTimer = null;
  function safeApprovedImage(variant) {
    const approved = variant?.approved_image;
    if (!approved || approved.visual_confirmed !== true || typeof approved.evidence !== 'string' || !approved.evidence.trim() || !approved.url || approved.url !== variant.variant_image_url) return null;
    try {
      const url = new URL(approved.url);
      if (url.protocol !== 'https:' || !['cdn.shopify.com','wehuiae.com'].includes(url.hostname)) return null;
      return url.href;
    } catch { return null; }
  }
  function selectedOptions(picker) {
    const values = new Map();
    for (const input of picker.querySelectorAll('input[data-option-name]:checked')) {
      const key=input.dataset.optionName;
      if (values.has(key) && values.get(key)!==input.value) return null;
      values.set(key,input.value);
    }
    for (const select of picker.querySelectorAll('select[data-option-name]')) {
      const key=select.dataset.optionName;
      if (values.has(key) && values.get(key)!==select.value) return null;
      values.set(key,select.value);
    }
    return values;
  }
  function resolveImage(input, selected) {
    if (!selected || !product.option_names.includes(input.dataset.optionName)) return null;
    const wanted = new Map(selected);
    wanted.set(input.dataset.optionName,input.value);
    if (product.option_names.some(name => !wanted.has(name))) return null;
    const variants = product.variants.filter(v => product.option_names.every(name => v.options?.[name] === wanted.get(name)));
    if (variants.length !== 1) return null; // Duplicate/conflicting option mappings fail closed.
    return safeApprovedImage(variants[0]);
  }
  function clearDecoration(label) {
    for(const img of label.querySelectorAll(ownImage)) img.remove();
    label.classList.remove('we-variant-image-label');
  }
  function render() {
    debounceTimer = null;
    for (const picker of document.querySelectorAll(pickerSelector)) {
      const selected = selectedOptions(picker);
      for (const input of picker.querySelectorAll('input[type="radio"][data-option-name]')) {
        if (!dimensions.some(d => d.name === input.dataset.optionName)) continue;
        const label = input.closest('label');
        if (!label || !picker.contains(label)) continue;
        // Keep existing native/custom images intact, including glasses/door swatches.
        if ([...label.querySelectorAll('img')].some(img => !img.matches(ownImage))) {clearDecoration(label);continue;}
        const url = resolveImage(input,selected);
        if (!url) {clearDecoration(label);continue;}
        let img = label.querySelector(ownImage);
        if (!img) {
          img = document.createElement('img');
          img.dataset.weVariantImageDecoration='1';img.alt='';img.setAttribute('aria-hidden','true');
          img.width=56;img.height=56;img.loading='lazy';img.decoding='async';
          img.addEventListener('error',()=>{if(img.isConnected)clearDecoration(label);},{once:true});
          label.append(img);
        }
        if (img.getAttribute('src') !== url) img.src=url;
        if (!label.classList.contains('we-variant-image-label')) label.classList.add('we-variant-image-label');
      }
    }
  }
  function schedule(){clearTimeout(debounceTimer);debounceTimer=setTimeout(render,40);}
  if (!document.getElementById('wehuiae-variant-image-options-style')) {
    const style=document.createElement('style');style.id='wehuiae-variant-image-options-style';
    style.textContent=pickerSelector+' label.we-variant-image-label:not([hidden]):not([aria-hidden="true"]){position:relative;isolation:isolate;display:inline-flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:8px;max-width:100%;width:auto;height:auto;min-height:44px;white-space:normal;box-sizing:border-box;padding:8px}'+pickerSelector+' '+ownImage+'{position:relative!important;z-index:2!important;display:block;width:56px;height:56px;max-width:100%;object-fit:contain;flex:0 0 56px;pointer-events:none}'+pickerSelector+' label.we-variant-image-label .variant-option__button-label__text{position:relative!important;z-index:2!important}'+pickerSelector+' label.we-variant-image-label .variant-option__button-label__pill{z-index:0!important;pointer-events:none}'+pickerSelector+' label.we-variant-image-label:focus-within{outline:2px solid currentColor;outline-offset:3px}'+pickerSelector+' fieldset:has(label.we-variant-image-label){flex-wrap:wrap;max-width:100%}@media(max-width:749px){'+pickerSelector+' label.we-variant-image-label{gap:6px;padding:6px}'+pickerSelector+' '+ownImage+'{width:48px;height:48px;flex-basis:48px}}';
    document.head.append(style);
  }
  document.addEventListener('change',event=>{if(event.target.closest?.(pickerSelector))schedule();},true);
  const isOwnNode = node => node.nodeType === 1 && node.matches?.(ownImage);
  const hasPicker = node => node.nodeType===1 && (node.matches?.(pickerSelector)||node.querySelector?.(pickerSelector));
  // Horizon can replace the whole main element. Attach to its stable ancestor,
  // but react only to this exact product picker or an ancestor containing it.
  const observeRoot=document.documentElement;
  if(observeRoot)new MutationObserver(records=>{
    if(records.some(record=>{
      const changed=[...record.addedNodes,...record.removedNodes];
      if(changed.length && changed.every(isOwnNode))return false;
      return !!record.target.closest?.(pickerSelector)||changed.some(hasPicker);
    }))schedule();
  }).observe(observeRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','value','data-option-name','data-product-id']});
  render();
})();
